import React from 'react'
import { Global } from '@emotion/react'
import { ChakraProvider } from '@chakra-ui/react'

import { MediaContextProvider } from './src/contexts/responsive'
import HeaderProvider from './src/contexts/header/Provider'
import globalStyles from './global-styles';
import SWRProvider from './src/contexts/SWRProvider';
import theme from './src/@chakra-ui/gatsby-plugin/theme'

const Providers = ({ element }) =>
  <ChakraProvider theme={theme} resetCSS>
    <MediaContextProvider>
      <HeaderProvider>
        <SWRProvider>
          <>
            <Global styles={globalStyles} />
            {element}
          </>
        </SWRProvider>
      </HeaderProvider>
    </MediaContextProvider>
  </ChakraProvider>

export default Providers
